import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {SliderService} from "../../serverService/sliderService/SliderService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {setSnackbarDispatch, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {css} from "@emotion/css";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import RaikoConfirmDialog from "../../raikoComponents/raikoCustomDialogs/RaikoConfirmDialog";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";

export default function SliderItemDetail(
    {
        id,
        handleUpdateRowGlobalInfo,
        handleUpdateThumbnailUrl,
        handleUpdatePublishedState
    }) {

    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const service = new SliderService()

    const [title, setTitle] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [link, setLink] = useState("");

    const [thumbnailFile, setThumbnailFile] = useState("");
    const [thumbnailUrl, setThumbnailUrl] = useState("");

    const [publishedState, setPublishedState] = useState(false);


    useEffect(() => {
        if (typeof id !== "undefined" && id >= 0) {
            getGlobalInfoFromServer()
        }
    }, [id])

    function getGlobalInfoFromServer() {
        loading.show()
        service.getSliderItemDetail(id)
            .then(({globalInfo, thumbnail, published}) => {
                console.log("g ", globalInfo)
                setTitle(globalInfo.title)
                setLink(globalInfo.link)
                setShortDescription(globalInfo.shortDescription)

                setThumbnailUrl(thumbnail.url)

                setPublishedState(published.published)

                loading.hide()
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئيات اسلاید"))
            loading.hide()
        })
    }


    function handleUpdateSliderItemGlobalInfo() {
        loading.show()
        service.updateSliderItemGlobalInfo(id, title, link, shortDescription)
            .then(response => {
                handleUpdateRowGlobalInfo(response)
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی جزئیات اسلایدر"))
            loading.hide()
        })
    }

    function handleUpdateThumbnail() {
        if (thumbnailFile) {
            loading.show()
            service.updateSliderItemThumbnail(id, thumbnailFile)
                .then(response => {
                    handleUpdateThumbnailUrl(response.url)
                    snackbar.showSuccessMessage("تصویر اسلایدر با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {

                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر اسلایدر."))
                loading.hide()
            })
        } else
            snackbar.showWarningMessage("لطفا ابتدا فایل تصویر شاخص را انتخاب نمایید.")
    }

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }

    function handleChangeEnableSetting() {
        loading.show()
        service.updateSliderItemPublishState(id, !publishedState)
            .then(response => {
                handleUpdatePublishedState(response.published)
                setPublishedState(response.published)
                snackbar.showSuccessMessage("وضعیت انتشار اسلاید با موفقیت بروزرسانی شد.")
                handleCloseConfirmDialog()
                loading.hide()
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی وضعیا انتشار اسلاید."))
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"انتشار مقاله"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!publishedState ? "انتشار" : "عدم انتشار"}
            />

            <RaikoGridOneColumn className={css`gap: 2rem;`}>
                <RaikoGridOneColumn className={`baseDashedBorderContainer ${css`background: unset;
                  padding: 1rem;
                  border-color: var(--header-border-bottom-color)`}`}>
                    <RaikoLabel className={css`width: fit-content`} text={"اطلاعات پایه"}/>
                    <RaikoSimpleInputOutlined
                        labelText={"عنوان"}
                        setValue={setTitle}
                        value={title}/>
                    <RaikoSimpleInputOutlined
                        labelText={"لینک مقصد"}
                        setValue={setLink}
                        value={link}/>
                    <RaikoSimpleMultiLineInputOutlined
                        labelText={"توضیحات کوتاه"}
                        setValue={setShortDescription}
                        value={shortDescription}/>
                    <ButtonDivisionSection>
                        <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateSliderItemGlobalInfo}/>
                    </ButtonDivisionSection>
                </RaikoGridOneColumn>

                <RaikoGridOneColumn
                    className={`baseDashedBorderContainer ${css`background: unset;
                      padding: 1rem;
                      border-color: var(--header-border-bottom-color)`}`}>
                    <RaikoLabel className={css`width: fit-content`} text={"تصویر شاخص"}/>
                    <UploadPhoto
                        photoFile={thumbnailFile}
                        setPhotoFile={setThumbnailFile}
                        photo={thumbnailUrl}
                        setPhoto={setThumbnailUrl}
                    />
                    <ButtonDivisionSection>
                        <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateThumbnail}/>
                    </ButtonDivisionSection>

                </RaikoGridOneColumn>

                <RaikoGridOneColumn
                    className={`baseDashedBorderContainer ${css`background: unset;
                      padding: 1rem;
                      text-align: start;
                      border-color: var(--header-border-bottom-color)`}`}>

                    <RaikoAlert
                        type={raikoAlertTypes.warning}
                        title={"وضعیت انتشار"}
                        description={[
                            "* با فعالسازی این مورد کاربران قادر به مشاهده ی این اسلاید خواهند بود و در غیر این صورت اسلاید تنها به عنوان پیش نویس در پنل مدیریت باقی خواهند ماند.",
                        ]}
                    />
                    <RaikoToggleOutlined
                        labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                        setChecked={state => {
                            handleOpenConfirmDialog()
                        }}
                        checked={publishedState}
                    />

                </RaikoGridOneColumn>

            </RaikoGridOneColumn>
        </>
    )
}